<ik-modal (OnClose)="dialogRef.close()">
    <ng-container header>
        {{'Profils de paiement' | transloco}}
    </ng-container>
    <ng-container main>
        <div class="description">
            <span
            [innerHTML]="'Votre partenaire sera uniquement autorise a utiliser le moyen de paiement que vous avez defini comme <strong>le moyen de paiement par defaut</strong> dans votre organisation <strong>$organization$</strong>.' | transloco:{organization: data.defaultBillingAddress.organization_name?data.defaultBillingAddress.organization_name:data.selectedAccount?.name}"></span>
        </div>
        <div class="profiles">
            <div class="profile">
                <ng-container *ngIf="data.defaultPaiementProfile.details_type === 'card'">
                    <div class="profile__icon">
                        <img [src]="data.defaultPaiementProfile.iconUrl"
                        [alt]="'Carte de credit' | transloco" />
                    </div>
                    <div class="profile__content">
                        <div class="profile__title"> **** **** **** {{data.defaultPaiementProfile.details.last4}}
                        </div>
                        <div class="profile__expiration">
                            {{'Expiration' | transloco}}
                            {{data.defaultPaiementProfile.details.expiry_month}}/{{data.defaultPaiementProfile.details.expiry_year}}
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="data.defaultPaiementProfile.details_type === 'prepaid'">
                    <div class="profile__icon">
                        <img [src]="data.defaultPaiementProfile.iconUrl"
                        [alt]="'Compte prepaye' | transloco" />
                    </div>
                    <div class="profile__content">
                        <div class="profile__title">
                            {{'Compte prepaye' | transloco}}
                        </div>
                        <div class="profile__expiration">
                            {{'Solde :' | transloco}} {{data.defaultPaiementProfile.details.amount}}
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="description">
            <span [innerHTML]="customText"></span>
        </div>
    </ng-container>
    <ng-container footer>
        <button class="btn-close"
        mat-flat-button
        mat-dialog-close
        [attr.aria-label]="'Fermer' | transloco"
        color="accent">
        {{ 'Fermer' | transloco }}
    </button>
</ng-container>
</ik-modal>
